/*
    const slider = new Slider(document.querySelector('.slider'));
    const slider2 = new Slider(document.querySelector('.slider'), {
        autoPosition: false,
        vertical: true
    });
    const slider3 = new Slider(document.querySelector('.slider'), {
        responsive:[
            {
                breakpoint: 1136,
                settings: {
                    autoPosition: false,
                    vertical: true
                }
            }
        ]
    });

    Settings list :

    - vertical: false,
    - slidesToScroll: 1,
    - center: true,
    - responsive: [],
    - autoPosition: true

*/


class Slider {
    constructor (element, options = {}) {

        this.element = element;
        this.options = { ...this.defaultOptions(), ...options };

        const width = window.innerWidth;

        if(options.responsive){
            for(let i=0; i<options.responsive.length; i++){
                const breakpoint = options.responsive[i].breakpoint;
                const settings = options.responsive[i].settings;
                if(width < breakpoint){
                    Object.assign(this.options, settings);
                }
            }
        }

        this.navFor = this.options.navFor;
        this.nav = this.options.nav;

        const arrowsExist = this.element.querySelector('[slider-arrows]') !== null;
        const prevArrowExist = this.element.querySelector('[slider-arrow-prev]') !== null;
        const nextArrowExist = this.element.querySelector('[slider-arrow-next]') !== null;
        this.arrows = arrowsExist || (prevArrowExist && nextArrowExist);

        this.dots = this.element.querySelector('[slider-dots]') !== null;

        this.currentSlide = 0;
        this.slides = this.element.querySelectorAll('[slider-slide]');
        this.sliderContainer = this.element.querySelector('[slider-container]');

        if(this.slides.length === 0) return;

        this.build();
        this.attachEvt();
    }

    defaultOptions() {
        return{
            vertical: false,
            slidesToScroll: 1,
            center: true,
            responsive: [],
            autoPosition: true
        }
    }

    build() {
        this.calculateSlidesInfo();

        this.sliderContainer.style.transition = 'none';
        if(!this.options.vertical) this.sliderContainer.style.transform = `translateX(0)`;
        else this.sliderContainer.style.transform = `translateY(0)`;

        if(this.arrows){
            const prevArrow = this.element.querySelector('[slider-arrow-prev]');
            const nextArrow = this.element.querySelector('[slider-arrow-next]');
            if (prevArrow && nextArrow) {
                prevArrow.addEventListener('click', () => this.prevSlide());
                nextArrow.addEventListener('click', () => this.nextSlide());
            }
        }

        if(this.dots){
            const dots = this.element.querySelector('[slider-dots]');
            dots.innerHTML = '';
            const classes = dots.getAttribute('slider-dot-class');
            for(let i=0;i<this.totalDots;i++){
                let dot = document.createElement('div');
                dot.classList.add(classes);
                dot.setAttribute('slider-dot', '');
                dot.addEventListener('click', () => this.goToSlide(i));
                dots.appendChild(dot);
            }
            this.updateDotsPosition();
        }
        this.startAutoSlide();
    }

    calculateSlidesInfo() {
        if(!this.options.vertical) this.slideWidth = this.slides[0].offsetWidth;
        else this.slideWidth = this.slides[0].offsetHeight;

        console.log(this.slideWidth);

        const style = window.getComputedStyle(this.sliderContainer);
        this.gap = parseInt(style.getPropertyValue('gap'), 10) || 0;
        this.slideWidth += this.gap;

        let sliderVisibleWidth;
        if(!this.options.vertical) sliderVisibleWidth = this.sliderContainer.offsetWidth;
        else sliderVisibleWidth = this.sliderContainer.offsetHeight;

        let slidesVisibleAtOnce = sliderVisibleWidth / this.slideWidth;

        if(slidesVisibleAtOnce - Math.floor(slidesVisibleAtOnce) >= 0.7) slidesVisibleAtOnce = Math.ceil(slidesVisibleAtOnce);
        else slidesVisibleAtOnce = Math.floor(slidesVisibleAtOnce);
        
        this.maxSlideIndex = Math.max(0, Math.ceil((this.slides.length - slidesVisibleAtOnce) / this.options.slidesToScroll));

        this.totalDots = this.maxSlideIndex + 1;

        if(this.maxSlideIndex === 0){

            if(this.options.center) this.sliderContainer.style.justifyContent = 'center';
            if(this.arrows){
                if(this.element.querySelector('[slider-arrows]')) this.element.querySelector('[slider-arrows]').classList.add('hidden');
                this.element.querySelector('[slider-arrow-prev]').classList.add('hidden');
                this.element.querySelector('[slider-arrow-next]').classList.add('hidden');
            }

            if(this.dots){
                this.element.querySelector('[slider-dots]').classList.add('hidden');
            }
        } else {
            if(this.options.center) this.sliderContainer.style.justifyContent = 'unset';

            if(this.arrows){
                if(this.element.querySelector('[slider-arrows]')) this.element.querySelector('[slider-arrows]').classList.remove('hidden');
                this.element.querySelector('[slider-arrow-prev]').classList.remove('hidden');
                this.element.querySelector('[slider-arrow-next]').classList.remove('hidden');
            }

            if(this.dots){
                this.element.querySelector('[slider-dots]').classList.remove('hidden');
            }
        }

        const totalWidthOfAllSlides = (this.slideWidth * this.slides.length);
        const padding = parseInt(style.getPropertyValue('padding'), 10) || 0;

        if(!this.options.vertical) this.overflow = totalWidthOfAllSlides - this.sliderContainer.offsetWidth - this.gap + padding * 2;
        else this.overflow = totalWidthOfAllSlides - this.sliderContainer.offsetHeight - this.gap + padding * 2;
    }
    
    updateSliderPosition(same = false) {
        this.currentSlide = Math.min(this.currentSlide, this.maxSlideIndex);
        let newTransformValue;

        if(this.currentSlide === this.maxSlideIndex){
            newTransformValue = -(this.overflow) + 'px';
        } else if(this.currentSlide <= 0){
            newTransformValue = 0;
            this.currentSlide = 0;
        } else{
            newTransformValue = -(this.slideWidth * this.currentSlide * this.options.slidesToScroll) + 'px';
        }

        this.sliderContainer.style.transition = 'transform 0.3s ease-out';
        
        if(!this.options.vertical) this.sliderContainer.style.transform = `translateX(${newTransformValue})`;
        else this.sliderContainer.style.transform = `translateY(${newTransformValue})`;

        if(this.dots) this.updateDotsPosition();

        this.stopAutoSlide();
        this.startAutoSlide();

        if(same) return;

        let changeSlideEvt = new CustomEvent('changeSlide', {
            detail: {
                index: this.currentSlide
            }
        });
        this.element.dispatchEvent(changeSlideEvt);
    }

    prevSlide() {
        if (this.currentSlide > 0) {
            this.currentSlide --;
            this.updateSliderPosition();
        } else {
            this.currentSlide = this.maxSlideIndex;
            this.updateSliderPosition();
        }
    }

    nextSlide() {
        if (this.currentSlide < this.maxSlideIndex) {
            this.currentSlide ++;
            this.currentSlide = Math.min(this.currentSlide, this.maxSlideIndex);
            this.updateSliderPosition();
        } else {
            this.currentSlide = 0;
            this.updateSliderPosition();
        }
    }

    goToSlide(index) {
        let same;
        if(this.currentSlide == index) same = true; 
        else same = false;

        if (index >= 0 && index < this.slides.length && this.slides.length > 1) {
            this.currentSlide = index;
            this.updateSliderPosition(same);
        }
    }

    updateDotsPosition() {            
        const dots = this.element.querySelectorAll('[slider-dot]');
        dots.forEach(dot => dot.classList.remove('active'));

        if (dots[this.currentSlide]) dots[this.currentSlide].classList.add('active');
    }

    attachEvt () {
        this.startX = 0;
        this.startY = 0;
        this.isDragging = false;

        if(this.maxSlideIndex === 0) return;

        this.fnStartDrag = this.startDrag.bind(this);
        this.fnEndDrag = this.endDrag.bind(this);
        this.fnDrag = this.drag.bind(this);

        this.element.addEventListener('mousedown', this.fnStartDrag);
        this.element.addEventListener('touchstart', this.fnStartDrag, { passive: true });

        this.element.addEventListener('mouseup', this.fnEndDrag);
        this.element.addEventListener('touchend', this.fnEndDrag);

        this.element.addEventListener('mousemove', this.fnDrag);
        this.element.addEventListener('touchmove', this.fnDrag, false);
    }

    startDrag(e) {
        this.sliderContainer.style.transition = 'none';
        this.isDragging = true;
        this.startX = e.pageX || e.touches[0].pageX;
        this.startY = e.pageY || e.touches[0].pageY;
    }

    endDrag(e) {
        if (!this.isDragging) return;
        this.isDragging = false;

        const endX = e.pageX || e.changedTouches[0].pageX;
        const endY = e.pageY || e.changedTouches[0].pageY;

        const moveDistanceX = endX - this.startX;
        const moveDistanceY = endY - this.startY;

        if(!this.options.vertical){
            if (Math.abs(moveDistanceX) > 50) {
                if (moveDistanceX > 0) {
                    this.goToSlide(this.currentSlide - Math.ceil(moveDistanceX / this.slideWidth));
                } else {
                    this.goToSlide(this.currentSlide + Math.ceil(Math.abs(moveDistanceX / this.slideWidth)));
                }
            } else {
                this.goToSlide(this.currentSlide);
            }
        } else {
            if (Math.abs(moveDistanceY) > 50) {
                if (moveDistanceY > 0) {
                    this.prevSlide();
                } else {
                    this.nextSlide();
                }
            }
        }
    }

    drag(e) {
        if (!this.isDragging) return;
        
        const currentX = e.pageX || e.touches[0].pageX;
        const currentY = e.pageY || e.touches[0].pageY;
    
        const deltaX = currentX - this.startX;
        const deltaY = currentY - this.startY;

        if(e.cancelable){

            if(!this.options.vertical){
                if(Math.abs(deltaX) > Math.abs(deltaY)){
                    e.preventDefault();
                }
            } else {
                if(Math.abs(deltaY) > Math.abs(deltaX)){
                    e.preventDefault();
                }
            }

        }

        const newTranslateX = Math.max(-(this.overflow), Math.min(0, deltaX - (this.currentSlide * this.slideWidth * this.options.slidesToScroll)));
        const newTranslateY = Math.max(-(this.overflow), Math.min(0, deltaY - (this.currentSlide * this.slideWidth * this.options.slidesToScroll)));

        if(!this.options.vertical) this.sliderContainer.style.transform = `translateX(${newTranslateX}px)`;
        else this.sliderContainer.style.transform = `translateY(${newTranslateY}px)`;
    }

    startAutoSlide() {
        if(!this.options.autoSlide || this.options.autoSlide == 0 || this.slides.length === 1) return;
        this.autoSlideTimer = setInterval(() => {
            this.nextSlide();
        }, this.options.autoSlide * 1000)
    }

    stopAutoSlide() {
        if(!this.options.autoSlide) return;
        clearInterval(this.autoSlideTimer);
    }

    buildNavFor() {
        if(!this.navFor) return;

        this.slides.forEach((slide, index) => {
            slide.addEventListener('click', () => {
                this.navFor.goToSlide(index);
                this.updateActiveSlide(index);
            })
        })

        this.updateActiveSlide(0);
    }

    buildNav() {
        if(!this.nav) return;

        this.element.addEventListener('changeSlide', (e) => {
            const index = e.detail.index;
            if(this.nav.maxSlideIndex) this.nav.goToSlide(Math.max(0, index - this.nav.options.navForActivePosition || 0));
            this.nav.updateActiveSlide(index);
        })
    }

    updateActiveSlide(index) {
        this.slides.forEach(slide => unsetActive(slide));
        setActive(this.slides[index]);
    }

    destroy() {
        this.element.removeEventListener('mousedown', this.fnStartDrag);
        this.element.removeEventListener('touchstart', this.fnStartDrag);

        this.element.removeEventListener('mouseup', this.fnEndDrag);
        this.element.removeEventListener('touchend', this.fnEndDrag);

        this.element.removeEventListener('mousemove', this.fnDrag);
        this.element.removeEventListener('touchmove', this.fnDrag);
    }

}